import React from 'react';
import { Pagination } from 'react-bootstrap';

const PaginationComponent = ({ paginationMeta, pageSize, onPageChange, disabled = false }) => {
  const { currentPage, totalPages, totalCount } = paginationMeta;

  const startItem = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  const items = [];
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  const go = page => {
    if (!disabled) onPageChange(page);
  };

  items.push(
    <Pagination.Prev key="prev" disabled={disabled || currentPage === 1} onClick={() => go(currentPage - 1)}>
      <span className="text-dark">&lt;</span>
    </Pagination.Prev>
  );

  if (startPage > 1) {
    items.push(
      <Pagination.Item key={1} disabled={disabled} onClick={() => go(1)}>
        <span className="text-dark">1</span>
      </Pagination.Item>
    );
    if (startPage > 2) {
      items.push(<Pagination.Ellipsis key="ellipsis1" />);
    }
  }

  for (let p = startPage; p <= endPage; p++) {
    items.push(
      <Pagination.Item key={p} active={p === currentPage} disabled={disabled} onClick={() => go(p)}>
        <span className="text-dark">{p}</span>
      </Pagination.Item>
    );
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      items.push(<Pagination.Ellipsis key="ellipsis2" />);
    }
    items.push(
      <Pagination.Item key={totalPages} disabled={disabled} onClick={() => go(totalPages)}>
        {totalPages}
      </Pagination.Item>
    );
  }

  items.push(
    <Pagination.Next key="next" disabled={disabled || currentPage === totalPages} onClick={() => go(currentPage + 1)}>
      <span className="text-dark">&gt;</span>
    </Pagination.Next>
  );

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap" style={{ gap: 12 }}>
      <div className="text-muted small">
        Showing {startItem} to {endItem} of {totalCount} entries
      </div>
      <Pagination className="mb-0">{items}</Pagination>
    </div>
  );
};

export default PaginationComponent;
